import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import { type SkillAnalyticsScope, type SkillAnalyticsType } from './skillAnalytics';
import META from './useTrackSkillUpdated.meta';

export type UseTrackSkillUpdatedParams = {
  scope: SkillAnalyticsScope;
  skill_id: string;
  type: SkillAnalyticsType;
};

export const useTrackSkillUpdated = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillUpdated = useCallback(
    (params: UseTrackSkillUpdatedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillUpdated };
};
